import { render, staticRenderFns } from "./DadosGerais.vue?vue&type=template&id=32d75113&scoped=true&"
import script from "./DadosGerais.vue?vue&type=script&lang=js&"
export * from "./DadosGerais.vue?vue&type=script&lang=js&"
import style0 from "./DadosGerais.vue?vue&type=style&index=0&id=32d75113&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d75113",
  null
  
)

export default component.exports